import { __exportAll } from "./_virtual/_rolldown/runtime.js";
//#region src/log.ts
var log_exports = /* @__PURE__ */ __exportAll({
	LogLevel: () => LogLevel,
	createDevLeveledLogger: () => createDevLeveledLogger,
	createTestLeveledLogger: () => createTestLeveledLogger,
	debug: () => debug,
	dev: () => dev,
	emailData: () => emailData,
	error: () => error,
	info: () => info,
	init: () => init,
	warn: () => warn
});
let LogLevel = /* @__PURE__ */ function(LogLevel) {
	LogLevel["Dev"] = "dev";
	LogLevel["Debug"] = "debug";
	LogLevel["Info"] = "info";
	LogLevel["Warn"] = "warn";
	LogLevel["Error"] = "error";
	LogLevel["EmailData"] = "email-data";
	return LogLevel;
}({});
let loggerSingleton = console.log;
function init(logger) {
	loggerSingleton = logger;
}
/**
* @description Should be used for dev messages only.
*/
function dev(...messages) {
	loggerSingleton("dev", ...messages);
}
/**
* @description Should be used for debugging only.
*/
function debug(...messages) {
	loggerSingleton("debug", ...messages);
}
/**
* @description Should be used for breadcrumbs or other critical steps that the app is doing.
*/
function info(...messages) {
	loggerSingleton("info", ...messages);
}
/**
* @description Should be used for non-fatal errors that the app is going to handle.
*/
function warn(...messages) {
	loggerSingleton("warn", ...messages);
}
/**
* @description Should be used for fatal errors that the app isn't going to handle.
*/
function error(...messages) {
	loggerSingleton("error", ...messages);
}
/**
* @description Should be used for fatal errors that the app isn't going to handle.
*/
function emailData(...messages) {
	loggerSingleton("email-data", ...messages);
}
function createDevLeveledLogger() {
	return {
		dev: (message) => {
			console.log(message);
		},
		debug: (message) => {
			console.log(message);
		},
		info: (message) => {
			console.log(message);
		},
		warn: (message) => {
			console.log(message);
		},
		error: (message) => {
			console.error(message);
		},
		emailData: (message) => {
			console.error(message);
		}
	};
}
function createTestLeveledLogger() {
	return {
		dev: (_message) => {},
		debug: (_message) => {},
		info: (_message) => {},
		warn: (_message) => {},
		error: (_message) => {},
		emailData: (message) => {
			console.log(message);
		}
	};
}
//#endregion
export { LogLevel, createDevLeveledLogger, createTestLeveledLogger, debug, dev, emailData, error, info, init, log_exports, warn };

//# sourceMappingURL=log.js.map